import { motion } from "framer-motion";
import { useApp } from "@/context/AppContext";
import { LANGS } from "@/content";

export const LanguageSelector = ({ className = "" }) => {
  const { lang, setLang } = useApp();
  return (
    <div
      data-testid="language-selector"
      className={`flex items-center gap-1 rounded-full border border-white/10 bg-white/5 p-1 backdrop-blur-xl ${className}`}
    >
      {LANGS.map((l) => {
        const active = l.code === lang;
        return (
          <button
            key={l.code}
            data-testid={`lang-${l.code}`}
            onClick={() => setLang(l.code)}
            className="relative rounded-full px-3 py-1.5 text-xs font-semibold tracking-wide transition-colors"
          >
            {active && (
              <motion.span
                layoutId="lang-pill"
                className="absolute inset-0 rounded-full bg-champagne"
                transition={{ type: "spring", stiffness: 400, damping: 32 }}
              />
            )}
            <span className={`relative z-10 flex items-center gap-1.5 ${active ? "text-navy" : "text-cream/70 hover:text-cream"}`}>
              <span aria-hidden="true">{l.flag}</span>
              {l.label}
            </span>
          </button>
        );
      })}
    </div>
  );
};
